/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `bales_alu` - Bales Alu
 * * `bales_hdpe` - Bales Hdpe
 * * `bales_pet` - Bales Pet
 * * `loose_alu` - Loose Alu
 * * `loose_pet` - Loose Pet
 */
export type SuperviselyDatasetEnum = typeof SuperviselyDatasetEnum[keyof typeof SuperviselyDatasetEnum];


export const SuperviselyDatasetEnum = {
  bales_alu: 'bales_alu',
  bales_hdpe: 'bales_hdpe',
  bales_pet: 'bales_pet',
  loose_alu: 'loose_alu',
  loose_pet: 'loose_pet',
} as const;
